import React from 'react'
import Banner from '../component/banner/Banner';
import styles from './styles/home.module.css';
import MainNavbar from '../component/navbar/Navbar';
import Embed from '../component/embed/Embed';
import Game from '../component/game/Game';
import Event from '../component/eventbanner/Event';
import Typewriter from '../component/typewriter/Typewriter';
import Shopping from '../component/shopping/Shopping';
import Birthday from '../component/birthday/Birthday';
import Footer from '../component/footer/Footer';
import ScrollMan from '../component/scrollMan/ScrollMan';

import bannerimg from "../assets/images/soltani.png"
import navid from "../assets/images/banner.png"
function Home() {
    return (
        <>
            <h1 className={styles.headerH}>ترامپولین پارک هلیوم</h1>
            <div className='newContainer'>
                <MainNavbar />
            </div>
            <div className={styles.content}>
                <Banner showButton={true} showMouseMove={true} bannerImage={bannerimg} mouseImage={navid}/>
            </div>
            <div className="embed-container">
                <Embed />
            </div>
            <div id= {styles.scrollContainer}>
                <ScrollMan />
            </div>
            <div className="slider-container">
                <Game />
            </div>
            <div className="birthbanner-container">
                <Birthday />
            </div>
            <div className="typer-container">
                <Typewriter />
            </div>
            <div>
                <Shopping />
            </div>
            <div className="banner-container">
                <Event />
            </div>
           
            <div className="mainFooter">
                <Footer />
            </div>
        </>
    )
}

export default Home;
